import { Component, OnInit } from '@angular/core';
import { ConsentTypes } from '@credit-acceptance/shareable-utilities';
import { ConsentTextInfoQueryService } from 'graphql-client';
import { map, takeUntil } from 'rxjs';

import { Unsubscribe } from '../shared/classes/unsubscribe.class';

@Component({
  selector: 'capq-product-terms',
  templateUrl: './product-terms.component.html',
  styleUrls: ['./product-terms.component.scss'],
})
export class ProductTermsComponent extends Unsubscribe implements OnInit {
  productTerms = '';
  showTermsSection = false;

  constructor(
    private ConsentTextInfoQueryService: ConsentTextInfoQueryService
  ) {
    super();
  }
  ngOnInit(): void {
    this.ConsentTextInfoQueryService.fetch({
      consentType: ConsentTypes.PRODUCT_TERMS,
    })
      .pipe(
        map((result) => result.data.getConsentByType),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((producterms) => {
        if (producterms) {
          this.productTerms = producterms.consenttext;
        }
      });
  }

  toggleTermsSection() {
    this.showTermsSection = !this.showTermsSection;
  }
}
